import React, { useEffect, useRef } from 'react';
import clearIcon from "assets/svgs/clear.svg";

export default function VirtualNumpadInput({ inputRef, inputId, onChange }) {
    const internalRef = useRef(null);

    useEffect(() => {
        if (!inputRef && inputId) {
            internalRef.current = document.querySelector(`#${inputId}`);
        }
    }, [inputId, inputRef]);

    const getInput = () => inputRef?.current || internalRef.current;

    // Prevent numpad buttons from taking focus (mobile browsers may scroll/jump on focus changes).
    // We manage the value manually, so keeping focus stable reduces viewport jitter.
    const preventButtonFocus = (event) => {
        event.preventDefault();
    };

    const updateValue = (newValue) => {
        const input = getInput();
        if (!input) return;

        input.value = newValue;

        if (typeof onChange === 'function') {
            const event = {
                target: input,
                currentTarget: input,
                bubbles: true,
                cancelable: true,
                defaultPrevented: false,
                isTrusted: true,
                nativeEvent: {},
            };
            onChange(event);
        }
    };

    const handleNumpadPress = (value) => {
        const input = getInput();
        if (!input || (input.type !== 'text' && input.type !== 'number')) return;

        // Don't allow decimal if one already exists
        if (value === '.' && input.value.includes('.')) return;

        // Don't allow more than 2 decimal places
        if (input.value.includes('.')) {
            const decimalPlaces = input.value.split('.')[1]?.length || 0;
            if (decimalPlaces >= 2) return;
        }
        const newValue = input.value + value;
        updateValue(newValue);
    };

    const handleDelete = () => {
        const input = getInput();
        if (!input || (input.type !== 'text' && input.type !== 'number')) return;
        const newValue = input.value.slice(0, -1);
        updateValue(newValue);
    };

    const handleClear = () => {
        const input = getInput();
        if (!input || (input.type !== 'text' && input.type !== 'number')) return;
        updateValue('');
    };

    const renderNumpad = () => (
        <div className="measurements-widget__numpad">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                <button
                    key={num}
                    type="button"
                    onPointerDown={preventButtonFocus}
                    onClick={() => handleNumpadPress(num.toString())}
                    className="measurements-widget__numpad-button"
                >
                    {num}
                </button>
            ))}
            <button type="button" onPointerDown={preventButtonFocus} onClick={() => handleNumpadPress('.')} className="measurements-widget__numpad-clear">.</button>
            <button type="button" onPointerDown={preventButtonFocus} onClick={() => handleNumpadPress('0')} className="measurements-widget__numpad-button">0</button>
            <button type="button" onPointerDown={preventButtonFocus} onClick={handleDelete} className="measurements-widget__numpad-delete">
                <img src={clearIcon} alt="Clear" />
            </button>
        </div>
    );

    return <>{renderNumpad()}</>;
}